import React from 'react';
import './reviewCard.css';

const ReviewCard = ({ review, type = 'employee' }) => {
  const { rating, comment, restaurant, employee, hiring } = review;
  
  // Get location from jobOffer if available
  const location = hiring?.jobOffer?.location?.address ||
                   restaurant?.locations?.[0]?.address ||
                   'Ubicación no especificada';

  // For employee reviews: show restaurant info
  // For restaurant reviews: show employee info
  const companyName = type === 'employee' 
    ? (restaurant?.name || 'Empresa')
    : (employee?.name ? `${employee.name} ${employee.surname || ''}`.trim() : 'Empleado');
  
  const companyLabel = type === 'employee' ? 'Empresa:' : 'Empleado:';

  // Render stars
  const renderStars = () => {
    return (
      <div className="review-card__stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`review-card__star ${star <= rating ? 'active' : ''}`}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="review-card">
      <div className="review-card__header">
        <div className="review-card__rating">
          {renderStars()}
          <span className="review-card__rating-number">{rating}/5</span>
        </div>
        <span className="review-card__date">{formatDate(review.createdAt)}</span>
      </div>
      
      <div className="review-card__content">
        <p className="review-card__comment">{comment}</p>
      </div>

      <div className="review-card__footer">
        <div className="review-card__company">
          <span className="review-card__company-label">{companyLabel}</span>
          <span className="review-card__company-name">{companyName}</span>
        </div>
        <div className="review-card__location">
          <span className="review-card__location-label">Ubicación:</span>
          <span className="review-card__location-name">{location}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;

